import type { SelectionPage, SelectionResult } from '@otto-ec/nexus-registry/selection';
import type { Page } from '@shared/types/Tilelist.ts';
import type { EventsOutgoing } from '@tilelist/application/ports/EventsOutgoing.ts';
import type { ViewportSize } from '@tilelist/application/ports/ViewportSize.ts';

export function publishLegacyResolution(
    eventsOutgoing: EventsOutgoing,
    viewport: ViewportSize,
    result: SelectionResult,
    ssid: string,
): void {
    eventsOutgoing.publishPageResolution({
        mergeOnPi: true,
        shouldScroll: viewport.isCompact(),
        rule: result.selection.rule,
        page: legacyPage(result.selection.page),
        redirect: result.selection.url,
        entryRule: result.selection.entryRule,
        ...(result.count !== undefined ? { count: result.count } : {}),
        ssid,
    });
}

function legacyPage(page: SelectionPage): Page {
    return {
        ...(page.layout !== undefined ? { l: page.layout } : {}),
        ...(page.offset !== undefined ? { o: page.offset } : {}),
        ...(page.sortOrder !== undefined ? { sortiertnach: page.sortOrder } : {}),
    };
}
